/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseCreateTireCommand } from '../models/ApiResponseCreateTireCommand';
import type { ApiResponseGetTireBoundResponse } from '../models/ApiResponseGetTireBoundResponse';
import type { ApiResponseGetTireRecommendedResponse } from '../models/ApiResponseGetTireRecommendedResponse';
import type { CreateTireCommand } from '../models/CreateTireCommand';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class TireService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 사용자 차량별 타이어 등록
   * 사용자 차량별 타이어를 등록합니다.
   * @returns ApiResponseCreateTireCommand OK
   * @throws ApiError
   */
  public createTire({
    requestBody,
  }: {
    requestBody: CreateTireCommand,
  }): CancelablePromise<ApiResponseCreateTireCommand> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/tire/dimension/',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 사용자 차량별 타이어 등록
   * 사용자 차량별 타이어를 등록합니다.
   * @returns ApiResponseCreateTireCommand OK
   * @throws ApiError
   */
  public createTire1({
    requestBody,
  }: {
    requestBody: CreateTireCommand,
  }): CancelablePromise<ApiResponseCreateTireCommand> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/tire/dimension',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 타이어 적정 공기압 결과 조회
   * 차종의 타이어 적정 공기압을 조회합니다.
   * @returns ApiResponseGetTireRecommendedResponse OK
   * @throws ApiError
   */
  public getTireRecommended({
    vin,
    puid,
    authorization,
  }: {
    vin: string,
    puid: string,
    authorization?: string,
  }): CancelablePromise<ApiResponseGetTireRecommendedResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/tire/recommended/',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'puid': puid,
      },
    });
  }
  /**
   * 타이어 적정 공기압 결과 조회
   * 차종의 타이어 적정 공기압을 조회합니다.
   * @returns ApiResponseGetTireRecommendedResponse OK
   * @throws ApiError
   */
  public getTireRecommended1({
    vin,
    puid,
    authorization,
  }: {
    vin: string,
    puid: string,
    authorization?: string,
  }): CancelablePromise<ApiResponseGetTireRecommendedResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/tire/recommended',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'puid': puid,
      },
    });
  }
  /**
   * 타이어 공기압 결과 조회
   * 타이어 공기압 결과를 조회합니다.
   * @returns ApiResponseGetTireBoundResponse OK
   * @throws ApiError
   */
  public getBatteryStatus({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseGetTireBoundResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/tire/bound/',
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * 타이어 공기압 결과 조회
   * 타이어 공기압 결과를 조회합니다.
   * @returns ApiResponseGetTireBoundResponse OK
   * @throws ApiError
   */
  public getBatteryStatus1({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseGetTireBoundResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/tire/bound',
      query: {
        'vin': vin,
      },
    });
  }
}
